import { userRoles } from '@/constants/user'
import { styleMetaKeys, optionMetaKeys } from '@/constants/meta'

/**
 * @returns {string}
 */
const getAppDomain = () => {
  const hostNameParts = window.location.hostname.split('.')
  hostNameParts.splice(0, 1)

  return hostNameParts.join('.')
}

/**
 * @param   {string}  email
 *
 * @returns {boolean}
 */
const isStitchEmail = email => email.search(/@(stitch3d\.com|stitchdesignlab\.com|stitch\.fashion|hatchstudio\.co)$/) > -1

/**
 * @param   {object}  user
 * @param   {number}  groupId
 *
 * @returns {boolean}
 */
const isUserCreatorInGroup = (user, groupId) => {
  if (user && groupId) {
    const permissions = user.permissions

    if (permissions) {
      return permissions.some(
        permission =>
          permission.role === userRoles.CREATOR &&
          permission.group.id === groupId
      )
    } else {
      return false
    }
  } else {
    return false
  }
}

/**
 * @param   {object} option
 *
 * @returns {object}
 */
const parseOptionMeta = option => {
  const meta = {}

  if (!option) {
    return meta
  }

  Object.values(optionMetaKeys).forEach(key => {
    if (option[key]) {
      meta[key] = option[key]
    }
  })

  return meta
}

/**
 * @param   {object} style
 *
 * @returns {object}
 */
const parseStyleMeta = style => {
  const meta = {}

  if (!style) {
    return meta
  }

  if (style.attributes) {
    Object.entries(style.attributes).forEach(([key, value]) => {
      meta[key] = value
    })
  }

  Object.values(styleMetaKeys).forEach(key => {
    if (style[key]) {
      meta[key] = style[key]
    }
  })

  return meta
}

/**
 * @param   {object}   style
 *
 * @returns {string[]}
 */
const parseStyleMetaNames = style => {
  let names = []

  if (!style) {
    return names
  }

  // adding flexible attributes
  if (style.attributes) {
    names = [...names, ...Object.values(style.attributes)]
  }

  // adding static attributes
  Object.values(styleMetaKeys).forEach(key => {
    const keyProcessed = key.replace(/_id$/, '')

    if (style[keyProcessed]) {
      names.push(style[keyProcessed].name)
    }
  })

  return names
}

/**
 * @param   {string} groupName
 *
 * @returns {string}
 */
const formatGroupName = groupName => {
  return groupName.replace(/_/g, ' ')
}

/**
 * @param {Array | string} keys
 */
const clearLocalStorage = keys => {
  if (keys && typeof keys === 'object') {
    keys.forEach(key => {
      localStorage.removeItem(key)
    })
  } else {
    localStorage.removeItem(keys)
  }
}

/**
 * @param   {string} url
 *
 * @returns {string}
 */
const processBaseUrl = url => {
  let processedUrl = url

  if (processedUrl.charAt(processedUrl.length - 1) !== '/') {
    processedUrl = `${processedUrl}/`
  }

  return processedUrl
}

const Utils = {
  getAppDomain,
  isStitchEmail,
  isUserCreatorInGroup,
  parseOptionMeta,
  parseStyleMeta,
  parseStyleMetaNames,
  formatGroupName,
  clearLocalStorage,
  processBaseUrl
}

export default Utils
